export var FontDisplay;

(function (FontDisplay) {
  FontDisplay["AUTO"] = "auto";
  FontDisplay["SWAP"] = "swap";
  FontDisplay["BLOCK"] = "block";
  FontDisplay["FALLBACK"] = "fallback";
  FontDisplay["OPTIONAL"] = "optional";
})(FontDisplay || (FontDisplay = {}));